import { useEffect, useRef } from 'react';

export default function useFocusTrap(closeFn, lastActiveRef) {
  const firstTrapRef = useRef(null);
  const lastTrapRef = useRef(null);
  const trapRef = useRef((e) => {
    if (e.keyCode === 27) {
      closeFn();
      lastActiveRef.current?.focus();
    }
    if (e.keyCode === 9 && document.activeElement === lastTrapRef.current) {
      firstTrapRef.current?.focus();
    }
    if (e.shiftKey && e.keyCode === 9 && document.activeElement === firstTrapRef.current) {
      lastTrapRef.current?.focus();
    }
  });

  const { current } = trapRef;

  useEffect(() => {
    window.addEventListener('keydown', current);
    lastTrapRef.current = document.activeElement;
    // firstTrapRef.current.focus();

    return () => {
      window.removeEventListener('keydown', current);
    };
  });

  return { firstTrapRef, lastTrapRef };
}
